document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".dropdown");
  [].forEach.call(dropdowns, (dropdown) => {
    dropdown.addEventListener("click", (e) => {
      if (e.target.closest(".dropdown-trigger")) {
        e.stopPropagation();
        dropdown.classList.toggle("is-active");
      } else if (e.target.closest(".dropdown-menu")) {
        // Let document-level handlers (including Rails UJS confirms and
        // data-method links) receive menu actions.
        dropdown.classList.remove("is-active");
      }
    });
  });
});
